module.exports = __webpack_public_path__ + "nebular.bf8ba1e0b1090942a59a.svg";


//////////////////
// WEBPACK FOOTER
// /srv/dev/FitRadioAdmin2/src/app/@nebular/icons/fonts/nebular.svg?jaecku
// module id = ../../../../../src/app/@nebular/icons/fonts/nebular.svg?jaecku
// module chunks = styles